// extracted by mini-css-extract-plugin
module.exports = {"contacts-poster":"Contacts_contacts-poster_27kWr","container":"Contacts_container_8wsUM"};